/**
 * @file コンポーネント：執刀医詳細モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";

// スタイル読み込み
import {
    StyledModalEdit,
    StyledModalEditLink,
    StyledModalEditLinkIcon,
    StyledModalEditLinkText,
    StyledModalHeadline,
    StyledModalParagraph,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {props.isShow === true && (
                // 執刀医名をクリックするまでレンダリングしない
                <Modal
                    buttonlist={[
                        // 執刀医の症例一覧へのリンク
                        {
                            buttonType: "submit",
                            href: props.href,
                            text: localized["Label.FindTheCasesForThisSurgeon"],
                        },
                    ]}
                    content={[
                        <React.Fragment key="modal">
                            {props.hospital && (
                                // 所属機関情報（無ければ表示しない）
                                <>
                                    <StyledModalHeadline>
                                        {localized["Label.AffiliatedHospital"]}
                                    </StyledModalHeadline>
                                    <StyledModalParagraph>
                                        {props.hospital}
                                    </StyledModalParagraph>
                                </>
                            )}
                            {(props.summary || props.isEditPage === true) && (
                                // 執刀医略歴（執刀医権限フル動画ページ以外は無ければ表示しない）
                                <>
                                    <StyledModalHeadline>
                                        {localized["Label.SurgeonSummary"]}
                                    </StyledModalHeadline>
                                    <StyledModalParagraph
                                        dangerouslySetInnerHTML={{
                                            __html: props.summary,
                                        }}
                                        ref={props.refSummary}
                                    />
                                    {props.isEditPage === true && (
                                        <StyledModalEdit>
                                            <StyledModalEditLink
                                                href="#"
                                                onClick={(e) =>
                                                    props.fnSetModalEdit(
                                                        e,
                                                        "surgeon",
                                                        "edit",
                                                        {
                                                            context:
                                                                props.refSummary
                                                                    .current
                                                                    .innerText,
                                                            id: props.surgeonId,
                                                            languageCode:
                                                                props.languageCode,
                                                            targets: [
                                                                props.refSummary
                                                                    .current,
                                                            ],
                                                        }
                                                    )
                                                }
                                            >
                                                <StyledModalEditLinkIcon>
                                                    <i className="fas fa-edit"></i>
                                                </StyledModalEditLinkIcon>
                                                <StyledModalEditLinkText>
                                                    {localized["Label.Edit"]}
                                                </StyledModalEditLinkText>
                                            </StyledModalEditLink>
                                        </StyledModalEdit>
                                    )}
                                </>
                            )}
                        </React.Fragment>,
                    ]}
                    hasButtonClose={true}
                    headline={props.fullname}
                    isShow={props.isShow}
                    setIsShow={props.setIsShow}
                />
            )}
        </>
    );
};
